import { useEffect, useState } from 'react';

export function useItemEstoqueModule({
    dados,
    novoProduto,
    setNovoProduto,

    operacaoParametros,

    MovimentoAPI,
    consultaFator,
}) {
    const [estoque, setEstoque] = useState({
        disponivel: 0,
        saldo: 0,
        fator: 1,
        carregado: false,
    });

    const [mensagemEstoque, setMensagemEstoque] = useState(null);

    useEffect(() => {
        if (!novoProduto?.empresaId || !novoProduto?.almoxarifadoId || !novoProduto?.produtoId) {
            setEstoque({
                disponivel: 0,
                saldo: 0,
                fator: 1,
                carregado: false,
            });
            setMensagemEstoque(null);
            return;
        }

        let ativo = true;

        async function fetchEstoque() {
            try {
                const fatorResult = await consultaFator(dados?.empresaId, novoProduto?.embalagemId);

                const response = await MovimentoAPI.calculaEstoques({
                    empresaId: novoProduto.empresaId,
                    almoxarifadoId: novoProduto.almoxarifadoId,
                    produtoId: novoProduto.produtoId,
                });

                if (!ativo) return;

                const saldo = MovimentoAPI.obterSaldoDisponivel(response.data);
                const fatorEmbalagem = Number(fatorResult?.fator || 1);
                const disponivel = Number(saldo / fatorEmbalagem || 0);

                setEstoque({
                    disponivel,
                    saldo: Number(saldo || 0),
                    fator: fatorEmbalagem,
                    carregado: true,
                });

                setNovoProduto((prev) => {
                    const disponivelFormatado = disponivel.toFixed(2);

                    if (prev?.disponivel === disponivelFormatado) {
                        return prev;
                    }

                    return {
                        ...prev,
                        disponivel: disponivelFormatado,
                    };
                });
            } catch (error) {
                console.error('Erro ao buscar estoque:', error);

                if (!ativo) return;

                setMensagemEstoque({
                    key: `erro-estoque-${Date.now()}`,
                    texto: 'Erro ao calcular estoque do produto.',
                    tipo: 'error',
                    tempo: 6,
                    msgPosition: 'top',
                });
            }
        }

        fetchEstoque();

        return () => {
            ativo = false;
        };
    }, [
        dados?.empresaId,
        novoProduto?.empresaId,
        novoProduto?.almoxarifadoId,
        novoProduto?.produtoId,
        novoProduto?.embalagemId,
        setNovoProduto,
        consultaFator,
    ]);

    const quantidade = Number(novoProduto?.quantidade || 0);

    const bloqueadoPorEstoque =
        !!operacaoParametros?.estoqueNegativo && estoque.carregado && quantidade > Number(estoque.disponivel || 0);

    useEffect(() => {
        if (!bloqueadoPorEstoque) {
            setMensagemEstoque(null);
            return;
        }

        setMensagemEstoque({
            key: `estoque-insuficiente-${Date.now()}`,
            texto: 'Saldo de estoque insuficiente.',
            tipo: 'warning',
            tempo: 6,
            msgPosition: 'top',
        });
    }, [bloqueadoPorEstoque]);

    return {
        state: {
            estoque,
            mensagemEstoque,
            bloqueadoPorEstoque,
        },
    };
}
